import { render, staticRenderFns } from "./AddProductTag.vue?vue&type=template&id=89277616&scoped=true"
import script from "./AddProductTag.vue?vue&type=script&lang=js"
export * from "./AddProductTag.vue?vue&type=script&lang=js"
import style0 from "./AddProductTag.vue?vue&type=style&index=0&id=89277616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89277616",
  null
  
)

export default component.exports